import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AfericaoService } from 'src/app/dio/afericao.service';
import { RemoveDialogService } from 'src/app/shared/components';
import { catchErr, showInputError } from 'src/app/shared/utils';

@Component({
    selector: 'app-cancelar-apontamento',
    templateUrl: './cancelar-apontamento.component.html',
    styleUrls: ['./cancelar-apontamento.component.css'],
    standalone: false
})
export class CancelarApontamentoComponent {

  loading: boolean;
  showInputError = showInputError;
  motivo: string;
  apontamento: any

  constructor(
    private afericaoService: AfericaoService,
    private snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<CancelarApontamentoComponent>,
    private removeDialogService: RemoveDialogService,
    @Inject(MAT_DIALOG_DATA) public data: { apontamento: any },
  ) {
    this.apontamento = data.apontamento;
  }

  public cancelar() {
    this.loading = true;    

    this.afericaoService.cancelarApontamento(this.apontamento.id, this.motivo).subscribe({
      next: (res) => {
          this.snackBar.open('Apontamento cancelado com sucesso', '✓', { panelClass: 'success' });
          this.dialogRef.close(true);
          window.location.reload();
                    
      }, error: (err) => {
          catchErr(err, this.snackBar);          
      }
    }).add(() => this.loading = false);

    /*
    this.removeDialogService.show('',
        (dialogRef: MatDialogRef<any>) => {
            
        },
        'Deseja mesmo cancelar esse apontamento?',
        'O apontamento será cancelado e não poderá ser recuperado',
        'Sim, Cancelar'
    );
    */    
  }
}
